import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../core/store';
import { ESyncLogsTabs } from '../../types';
import * as settings from './settings';
import { useLocation } from 'react-router-dom';
import { ModePage } from '../../../core/types/common/ConfigPageComponent';

const useSettings = () => {
    const dispatch = useDispatch();
    const startDate = useAppSelector(settings.selectors.getStartDate);
    const endDate = useAppSelector(settings.selectors.getEndDate);
    const appLink = useAppSelector(settings.selectors.getAppLink);

    const { pathname } = useLocation();
    const tab = getTab(pathname, appLink);

    const changeStartDate = useCallback(
        (startDate: Date | undefined) => {
            dispatch(settings.actions.setStartDate(startDate));
        },
        [dispatch],
    );

    const changeEndDate = useCallback(
        (EndDate: Date | undefined) => {
            dispatch(settings.actions.setEndDate(EndDate));
        },
        [dispatch],
    );

    const changeTab = useCallback(
        (tab: ESyncLogsTabs) => {
            dispatch(settings.actions.setCurrentTab(tab));
            dispatch(settings.actions.setEndDate(undefined));
        },
        [dispatch],
    );

    const setAppLink = useCallback(
        (appLink: string) => {
            dispatch(settings.actions.setAppLink(appLink));
        },
        [dispatch],
    );
    const setModePage = useCallback(
        (modePage: ModePage) => {
            dispatch(settings.actions.setModePage(modePage));
        },
        [dispatch],
    );

    useEffect(()=> {
        changeTab(tab as unknown as ESyncLogsTabs);
    }, [pathname, changeTab, tab]);

    return {
        appLink: appLink,
        startDate,
        endDate,
        currentTab: tab,
        changeStartDate,
        changeEndDate,
        changeTab,
        setAppLink,
        setModePage
    };
};

export default useSettings;

const getTab = (link: string, appLink: string) => {
    const names = link.split('/');

    if (names[1] === appLink) {
        return names[2];
    }

    return ESyncLogsTabs.relatics.toString();
};
